import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './Tasks.css';

function fmtDay(iso) {
  const d = new Date(iso);
  return d.getDate() + '/' + (d.getMonth() + 1);
}

function fmtDate(iso) {
  return new Date(iso).toLocaleDateString('ru-RU');
}

function isWeekend(iso) {
  const d = new Date(iso);
  return d.getDay() === 0 || d.getDay() === 6;
}

export default function ResourceLoad() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(14);
  const [start, setStart] = useState(() => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.getResourceLoad({ start, days });
      setData(res.data);
    } catch (e) {
      setData(null);
    }
    setLoading(false);
  }, [start, days]);

  useEffect(() => { load(); }, [load]);

  const cellClass = (n) => {
    if (n === 0) return 'rl-cell';
    if (n === 1) return 'rl-cell load-1';
    if (n <= 3) return 'rl-cell load-2';
    return 'rl-cell load-3';
  };

  return (
    <div className="tasks-page">
      <div style={{ marginBottom: 8 }}>
        <Link to="/tasks" style={{ color: '#6b7280', textDecoration: 'none', fontSize: 14 }}>← Дашборд задач</Link>
      </div>
      <h1>Загрузка сотрудников</h1>
      <p style={{ color: '#6b7280', marginTop: -8 }}>
        Матрица задач по каждому исполнителю за выбранный период. Зелёный — норма (1 задача), жёлтый — умеренная нагрузка (2-3), красный — перегруз (≥4).
      </p>

      <div className="tasks-toolbar">
        <label style={{ fontSize: 13 }}>
          Начало периода:
          <input
            type="date"
            className="tasks-input"
            style={{ maxWidth: 160, marginLeft: 6 }}
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
        </label>
        <label style={{ fontSize: 13 }}>
          Дней:
          <select
            className="tasks-select"
            style={{ maxWidth: 100, marginLeft: 6 }}
            value={days}
            onChange={(e) => setDays(parseInt(e.target.value, 10))}
          >
            <option value={7}>7 (неделя)</option>
            <option value={14}>14 (2 недели)</option>
            <option value={30}>30 (месяц)</option>
            <option value={60}>60</option>
          </select>
        </label>
      </div>

      {loading ? (
        <div className="tasks-empty">Загрузка…</div>
      ) : !data || !data.users || data.users.length === 0 ? (
        <div className="tasks-empty">В этом периоде нет активных задач у сотрудников</div>
      ) : (
        <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff' }}>
          <table className="rl-table">
            <thead>
              <tr>
                <th className="rl-user-col">Сотрудник</th>
                <th className="rl-total-col" title="Сумма всех задач за период">Итого</th>
                <th className="rl-peak-col" title="Максимум задач в один день">Пик</th>
                {data.days.map((d) => (
                  <th key={d} className={`rl-day-col ${isWeekend(d) ? 'weekend' : ''}`} title={fmtDate(d)}>
                    {fmtDay(d)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.users.map((u) => (
                <tr key={u.user_id}>
                  <td className="rl-user-name">
                    <strong>{u.user_name}</strong>
                    {u.department && <div style={{ fontSize: 11, color: '#6b7280' }}>{u.department}</div>}
                  </td>
                  <td className="rl-num">{u.total}</td>
                  <td className={u.peak >= 4 ? 'rl-num overload' : 'rl-num'}>{u.peak}</td>
                  {u.daily.map((n, i) => (
                    <td
                      key={i}
                      className={`${cellClass(n)} ${isWeekend(data.days[i]) ? 'weekend' : ''}`}
                      title={n === 0 ? 'нет задач' : `${n} задач(и)`}
                    >
                      {n || ''}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
